import { BranchOperatingHoursPage } from "@/features/branch-sales-channel/pages/BranchOperatingHoursPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/branch-sales-channel/$id/operating-hours",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["branch_sales_channel_merchant_maps.edit"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: BranchOperatingHoursPage,
});
